require('../../modules/es6.object.define-properties');
var $Object = require('../../modules/_core').Object;
module.exports = function defineProperties(T, D) {
  return $Object.defineProperties(T, D);
};



//////////////////
// WEBPACK FOOTER
// /var/www/smartbuy.ru/~/babel-runtime/~/core-js/library/fn/object/define-properties.js
// module id = 57
// module chunks = 0 2 6 7 10 11 13 14 17 19 21 22 25 41 43 44 45 47 48 49 51